import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n/i18n'
import VueRouter from 'vue-router';
import './assets/css/global.css'
import {publicPath} from "../vue.config";
import isEmpty from './mixins/isempty'
import store from './store'
import ConfigPage from "@/components/config-page/main/ConfigPage";
import Notifications from 'vue-notification'
import StartPage from "./components/start-page/StartPage";
//import OverviewPage from "@/components/overview-page/main/OverviewPage";

Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(Notifications)

export const bus = new Vue();




/**
 * Router. Further information: https://router.vuejs.org/
 * @type {VueRouter}
 */
export const router = new VueRouter({
    mode: 'history',
    routes: [
        { path: publicPath + '/configuration/model/:maxStklId/type/:type/size/:size',       name: 'ConfigPageBySizeType' , component: ConfigPage },
        { path: publicPath + '/configuration/model/:maxStklId',                             name: 'ConfigPageByMaxStklId', component: ConfigPage },
        { path: publicPath + '/backToStandardConfig',                                       name: 'ConfigPageStandard', component: ConfigPage },
        { path: publicPath + '/configuration/article/:articleNumber/:deliveryCondition',    name: 'ConfigPageByArticleNo', component: ConfigPage },
        { path: publicPath + '/products',                                             name: 'StartPage', component: StartPage},
        // { path: publicPath + '/overview', name: 'Overview', component: OverviewPage, props: true},
        // { path: '/*', name: 'FallbackToConfigPage', component: ConfigPage } // TODO 404
        { path: '/*', name: 'Fallback', redirect: {name: 'StartPage'} } // TODO 404
    ]
});

new Vue({
    mixins: [isEmpty],
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount('#app');

